
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a7b1e7d0-a401-58d6-8939-c6e3cf3d8959")}catch(e){}}();
customElements.get("seller-comments")||customElements.define("seller-comments",class extends HTMLElement{constructor(){super()}connectedCallback(){var e=this.dataset.sellerId;e&&this.fetchComments(e)}adaptComment(e){return{score:e.grade,text:e.comment,name:e.firstname,createdAt:e.date}}formatDate(e){return Intl.DateTimeFormat("es-ES",{day:"numeric",month:"long",year:"numeric"}).format(new Date(e))}async fetchComments(e){try{var t=(await(await fetch(ntsapps_mkl+"mirakl/evaluations",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({shop:e})})).json()).data.map(this.adaptComment);console.log(t),t&&0!==t.length?(this.renderComments(t),document.querySelector(".js-seller-comments-count").innerHTML=`&nbsp;(${t.length})`):this.renderMessage(this.dataset.noCommentsText)}catch(e){console.error("Error al cargar comentarios:",e),this.renderError(this.dataset.apiErrorText)}}renderComments(e){let n=Array.from({length:5},(e,t)=>t+1);e=e.map(t=>{var e=`
            ${n.map(e=>`
              <div class="!tw-m-0">
                ${e>t.score?'<i class="tw-text-base tw-text-[#a0aec0] icon-ph-star-o"></i>':'<i class="tw-text-base tw-text-[#589d7a] icon-ph-star-o"></i>'}
              </div>
            `).join("")}
            <p>(${this.escape(t.score)})</p>
          `;return`
          <div class="comment">
            <div class="comment-header">
              <p class="comment-title">${this.escape(t.name)}</p>
              <div class="tw-flex tw-gap-1">
                ${e}
              </div>
            </div>
            <p class="comment-date">${this.formatDate(t.createdAt)}</p>
            <div class="comment-body">
              ${this.escape(t.text)}
            </div>
          </div>
        `}).join("");this.innerHTML=`
          <style>
            .comment {
              border: 1px solid #e5e7eb;
              border-radius: 8px;
              padding: 12px;

            }

            .comment:not(:first-of-type) {
              margin-top: 16px;
            }

            .comment-header {
              align-items: center;
              display: flex;
              gap: 16px;
            }

            .comment-title {
              color: #4a5568;
              font-weight: 700;
              margin: 0;
            }

            .comment-date {
              color: #a0aec0;
              font-size: 14px;
              font-weight: 500;
              margin: 4px 0 0;
            }

            .comment-body {
              font-size: 1.6rem;
              line-height: 2.4rem;
              font-weight: 700;
              color: #718096;
              margin-top: 8px;
            }
          </style>
          <div class="comment-container">
            ${e}
          </div>
        `}renderMessage(e){this.innerHTML=`<p>${e}</p>`}renderError(e){this.innerHTML=""+e}escape(e){var t=document.createElement("div");return t.textContent=e,t.innerHTML}});
//# sourceMappingURL=seller-comments.js.map

//# debugId=a7b1e7d0-a401-58d6-8939-c6e3cf3d8959
